import "./workorders.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import WorkorderTable from "../../components/workorderTable/workorderTable";

const Workorders = () => {
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <WorkorderTable />
      </div>
    </div>
  );
};

export default Workorders;
